import { useQuery } from '@tanstack/react-query';

const ETHIOPIAN_REGIONS = [
  'Addis Ababa',
  'Oromia', 
  'Sidama',
  'Amhara',
  'Tigray',
  'Somali',
  'Afar',
  'Harari',
  'South Ethiopia Region',
  'South West',
  'Central Ethiopia Region',
  'Gambela',
  'Benishangul-Gumuz'
];

export const useFarmRegions = () => {
  return useQuery({
    queryKey: ['farm-regions'],
    queryFn: () => Promise.resolve(ETHIOPIAN_REGIONS),
    staleTime: Infinity, // Regions don't change
  });
};